import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {Message} from 'element-ui'
import {Route} from 'vue-router'
import {UserModule} from '@/store/modules/user'
import {PermissionModule} from '@/store/modules/permission'
import i18n from '@/lang' // Internationalization
// import settings from './settings'

NProgress.configure({showSpinner: false})

const whiteList = ['/login', '/auth-redirect']

// const getPageTitle = (key: string) => {
//   const hasKey = i18n.te(`route.${key}`)
//   if (hasKey) {
//     const pageName = i18n.t(`route.${key}`)
//     return `${pageName} - ${settings.title}`
//   }
//   return `${settings.title}`
// }

router.beforeEach(async (to: any, from: any, next: any) => {
  // 开始进度条
  NProgress.start()
  if (to.path === '/login') return next()
  if (to.path === '/register/register') return next()
  const json = window.sessionStorage.getItem("json")
  if (json) {
    next()
  } else {
    next('/login')
  }
  // NProgress.start()
  // if (to.path === '/login') {
  //   next()
  // }
  // else {
  //   //  json不存在跳转到登陆页面
  //   var json: any = window.sessionStorage.getItem("json")
  //   console.log(json)
  //   if (json === null) {
  //     next('/login')
  //   }
  //   else {
  //     let orglength = JSON.parse(json).orgnizeid
  //     // 组织id为空是游客登录跳转到个人中心下，管理员得组织id大于一位
  //     if (orglength !== "") {
  //       next()
  //     }
  //     else {

  //       if (to.path === '/userinfo/userinfo' && json) {
  //         next()
  //       }
  //       else {
  //         next('/userinfo/userinfo')
  //       }
  //     }
  //   }
  // }


  // 确定用户是否已登录
  // if (UserModule.token) {
  //   if (to.path === '/login') {
  //     // 如果已登录，请重定向到主页
  //     next({ path: '/' })
  //     NProgress.done()
  //   } else {
  //     // 检查用户是否已获得其权限角色
  //     if (UserModule.roles.length === 0) {
  //       try {

  //         // 角色权限必须是对象数组！例如：['admin']或['developer'，'editor']
  //         await UserModule.GetUserInfo()
  //         const roles = UserModule.roles
  //         console.log(roles)
  //         // 基于角色生成可访问路由图
  //         PermissionModule.GenerateRoutes(roles)
  //         // 动态添加可访问路由
  //         console.log(PermissionModule.dynamicRoutes)
  //         router.addRoutes(PermissionModule.dynamicRoutes)
  //         // 确保addRoutes是完整的
  //         // 设置replace:true，这样导航就不会留下历史记录
  //         next({ ...to, replace: true })
  //       } catch (err) {
  //         // 删除token并重定向到登录页
  //         // UserModule.ResetToken()
  //         // Message.error(err || 'Has Error')
  //         // next(`/login?redirect=${to.path}`)
  //         next()
  //         NProgress.done()
  //       }
  //     } else {
  //       next()
  //     }
  //   }
  // } else {
  //   if (whiteList.indexOf(to.path) !== -1) {
  //     // 在免费登录白名单中，直接进入
  //     next()
  //   } else {
  //     // 没有访问权限的其他页将重定向到登录页
  //     // next(`/login?redirect=${to.path}`)
  //     next(`/login`)
  //     NProgress.done()
  //   }
  // }
})

router.afterEach((to: Route) => {
  // Finish progress bar
  NProgress.done()

  // set page title
  // document.title = getPageTitle(to.meta.title)
  document.title = to.meta.title
})
